import { useState, useEffect } from "react";

const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const errorHandler = (error, errorInfo) => {
      // console.error("Caught an error:", error, errorInfo);
      setHasError(true);
    };

    window.addEventListener("error", errorHandler);
    window.addEventListener("unhandledrejection", errorHandler);

    return () => {
      window.removeEventListener("error", errorHandler);
      window.removeEventListener("unhandledrejection", errorHandler);
    };
  }, []);

  if (hasError) {
    return (
        <div style={{height:"100vh",justifyItems:"center",alignContent:"center"}}>
          <h1>Something went wrong. Please try again later.</h1>
        </div>)
  }

  return children;
};

export default ErrorBoundary;


// ----------------------

// import React from 'react';

// class ErrorBoundary extends React.Component {
//   state = { hasError: false };

//   static getDerivedStateFromError(error) {
//     return { hasError: true };
//   }

//   componentDidCatch(error, errorInfo) {
//     // Optionally log the error to an error reporting service
//     console.error('Caught an error:', error, errorInfo);
//   }

//   render() {
//     if (this.state.hasError) {
//       return (
//         <div style={{ height: '100vh', display: 'grid', placeItems: 'center' }}>
//           <h1>Something went wrong. Please try again later.</h1>
//         </div>
//       );
//     }
//     return this.props.children;
//   }
// }

// export default ErrorBoundary;
